import appGlobalScript from '/home/cynthia/projects/personal/nonodle/nonoui/src/global/app.ts';
export const globalScripts = appGlobalScript;
